import { Popover, Button, Col, Input, InputNumber, Row, Select, Spin, Switch, Radio } from 'antd';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ENV } from '../utils/http';
import styles from './newsletter.css';
import {
	edit,
	editAttr,
	save,
	deleteNewsletter,
	editGenerateAttr,
	generate,
	fetchNewsletters,
} from './newsletterActions';
import DayOfWeekComponent from '../components/dayOfWeek';

const { TextArea } = Input;
const Option = Select.Option;

const RadioGroup = Radio.Group;

class NewsletterEditComponent extends Component {
	state = {
		generateType: 'sbt',
		confirmDeleteVisible: false,
	};

	componentDidMount() {
		this.props.dispatch(edit(this.props.match.params.id));
	}

	onChangeValue(e, attr) {
		this.props.dispatch(editAttr(e, attr));
	}

	onChangeGenerateAttr(attr, value) {
		if (attr === 'url') {
      // Ensure url is always https.
			if (value.startsWith('http://')) {
				value = value.replace('http://', 'https://');
			}
		}

		this.props.dispatch(editGenerateAttr(attr, value));
	}

	preview() {
		window.open(`${ENV.url}/nyhetsbrev/${this.props.newsletter.id}/email/2`, '_blank');
	}

	generate() {
		this.props.dispatch(generate(this.props.generate));
	}

	deleteNewsletter() {
		this.setState({
			confirmDeleteVisible: false,
		});

		this.props.dispatch(deleteNewsletter(this.props.newsletter.id));
	}

	save() {
		this.props.dispatch(save(this.props.newsletter));
		setTimeout(() => this.props.dispatch(fetchNewsletters(this.props.week)), 300);
	}

	render() {
		let confirmPopup = (
			<div>
				<Button onClick={() => this.deleteNewsletter()}>Ja</Button>
				<Button
					style={{ marginLeft: 10 }}
					onClick={() => this.setState({ confirmDeleteVisible: false })}
				>
					Nej
				</Button>
			</div>
		);

		return (
			<div>
				<Spin spinning={this.props.loading}>
					{this.props.newsletter && (
						<div>
							<Row style={{ marginBottom: 10 }}>
								<Col>
									<span style={styles.formLabel}>År: </span>
									<InputNumber
										defaultValue={this.props.newsletter.year}
										onChange={(e) => this.onChangeValue(e, 'year')}
										min={2000}
										max={3000}
									/>
									<span style={styles.formLabel}>Vecka: </span>
									<InputNumber
										defaultValue={this.props.newsletter.week}
										onChange={(e) => this.onChangeValue(e, 'week')}
										min={1}
										max={53}
									/>
									<span style={styles.formLabel}>Databas: </span>
									<Select
										defaultValue={this.props.newsletter.database}
										onChange={(e) => this.onChangeValue(e, 'database')}
									>
										{this.props.newsletter.databases.map((entry) => (
											<Option key={entry.key} value={entry.key}>
												{entry.name}
											</Option>
										))}
									</Select>
									<span style={styles.formLabel}>Publicerad till kund: </span>
									<Switch
										defaultChecked={this.props.newsletter.published}
										onChange={(e) => this.onChangeValue(e, 'published')}
									/>

									<Button
										type='primary'
										size='large'
										onClick={() => this.save()}
										style={{ float: 'right' }}
									>
										Spara
									</Button>
									{this.props.newsletter.id !== -1 && (
										<Button
											icon='search'
											style={{ float: 'right', marginRight: 10 }}
											size='large'
											type='secondary'
											onClick={() => this.preview()}
										>
											Förhandsgranska
										</Button>
									)}
									{this.props.newsletter.id !== -1 && (
										<Popover
											visible={this.state.confirmDeleteVisible}
											placement='topLeft'
											title={'Är du säker?'}
											content={confirmPopup}
											trigger='click'
										>
											<Button
												style={{ float: 'right', marginRight: 10 }}
												size='large'
												type='danger'
												onClick={() => this.setState({ confirmDeleteVisible: true })}
											>
												Radera
											</Button>
										</Popover>
									)}
								</Col>
							</Row>
							<Row style={styles.toolbar}>
								<Col span={14}>
									<div>Titel</div>
									<Input
										defaultValue={this.props.newsletter.titleInContent}
										onBlur={(e) => this.onChangeValue(e.target.value, 'titleInContent')}
									/>
									<div>E-post ämne</div>
									<Input
										defaultValue={this.props.newsletter.title}
										onBlur={(e) => this.onChangeValue(e.target.value, 'title')}
									/>
									<div>Utskicksdatum</div>
									<Input
										defaultValue={this.props.newsletter.sendDate}
										onBlur={(e) => this.onChangeValue(e.target.value, 'sendDate')}
									/>
									<div>Innehåll</div>
									<TextArea
										style={styles.textarea}
										defaultValue={this.props.newsletter.content}
										onBlur={(e) => this.onChangeValue(e.target.value, 'content')}
									/>
								</Col>
								<Col span={10} style={{ padding: '0 20px 20px 20px' }}>
									<Row>
										<h2>Generera</h2>
									</Row>

									<Row>
										<RadioGroup
											onChange={(e) => this.onChangeGenerateAttr('type', e.target.value)}
											defaultValue={'sbt'}
										>
											<Radio value={'sbt'}>Rättsfall m.m.</Radio>
											<Radio value={'sbl'}>Lag</Radio>
											<Radio value={'sba'}>Lagändring</Radio>
											<Radio value={'http'}>Extern webblänk</Radio>
											<Radio value={'news'}>Senaste nyheter</Radio>
											<Radio value={'video'}>Videolänk</Radio>
										</RadioGroup>
									</Row>
									{['sbt', 'sbl', 'sba'].includes(this.props.generate.type) && (
										<div>
											<Row style={{ marginTop: 10 }}>Produktionsbeteckning</Row>
											<Row>
												<Input
													value={this.props.generate.originalFilename}
													onChange={(e) =>
														this.onChangeGenerateAttr('originalFilename', e.target.value)
													}
												/>
											</Row>
										</div>
									)}
									{this.props.generate.type === 'news' && (
										<div>
											<Row style={{ marginTop: 10 }}>
												Inkludera nyheter från (
												<DayOfWeekComponent date={this.props.generate.includeFromDate} />)
											</Row>
											<Row>
												<Input
													value={this.props.generate.includeFromDate}
													onChange={(e) =>
														this.onChangeGenerateAttr('includeFromDate', e.target.value)
													}
												/>
											</Row>
										</div>
									)}
									{['http', 'video'].includes(this.props.generate.type) && (
										<div>
											<Row style={{ marginTop: 10 }}>Länktitel</Row>
											<Row>
												<Input
													value={this.props.generate.title}
													onChange={(e) => this.onChangeGenerateAttr('title', e.target.value)}
												/>
											</Row>
											<Row style={{ marginTop: 20 }}>Länkadress</Row>
											<Row>
												<Input
													value={this.props.generate.url}
													onChange={(e) => this.onChangeGenerateAttr('url', e.target.value)}
												/>
											</Row>
										</div>
									)}
									{this.props.generate.type === 'sbl' && (
										<Row style={{ marginTop: 20 }}>
											<Col span={8}>Kapitel</Col>
											<Col span={8}>Paragraf</Col>
											<Col span={8}>Rubrik</Col>
										</Row>
									)}

									{this.props.generate.type === 'sbl' && (
										<Row>
											<Col span={8}>
												<Input
													onBlur={(e) => this.onChangeGenerateAttr('chapter', e.target.value)}
												/>
											</Col>
											<Col span={8}>
												<Input
													onBlur={(e) => this.onChangeGenerateAttr('paragraph', e.target.value)}
												/>
											</Col>
											<Col span={8}>
												<Input
													onBlur={(e) => this.onChangeGenerateAttr('additional', e.target.value)}
												/>
											</Col>
										</Row>
									)}

									<Row>
										<Button
											icon='arrow-down'
											style={styles.generateButton}
											type='secondary'
											onClick={() => this.generate()}
										>
											Generera
										</Button>
									</Row>
									<Row>
										<TextArea
											style={styles.textareaGenerate}
											placeholder='Klicka på generera för att skapa länk och se resultatet här'
											value={this.props.generate.preview}
										/>
									</Row>
								</Col>
							</Row>
						</div>
					)}
				</Spin>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		loading: state.newsletter.loading,
		newsletter: state.newsletter.newsletter,
		generate: state.newsletter.generate,
		week: state.newsletter.week,
	};
};

export default connect(mapStateToProps)(NewsletterEditComponent);



// WEBPACK FOOTER //
// ./src/newsletter/newsletterEditComponent.js